/* eslint-disable max-len */
import React, { useState } from 'react';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { Typography, AccordionDetails } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Add, Minimize } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  accordion: {
    marginBottom: '10px',
    boxShadow: '0 0px 24px 0 rgba(0, 0, 0, 0.08)',
    borderRadius: '4px',
    '&::before': {
      height: '0px',
    },
  },
}));

const Accordion = (props) => {
  const {
    children, title, expandedSeparatedButton, setExpandedSeparatedButton, extraButton,
  } = props;
  const classes = useStyles(props);
  const [expanded, setExpanded] = useState(extraButton ? setExpandedSeparatedButton : false);

  return (
    <>
      {extraButton ? (
        <MuiAccordion expanded={expandedSeparatedButton} onClick={(() => setExpandedSeparatedButton(!expandedSeparatedButton))} className={clsx(classes.accordion)}>
          <MuiAccordionSummary expandIcon={expandedSeparatedButton ? <Minimize /> : <Add />}>
            <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>{title}</Typography>
          </MuiAccordionSummary>
          <AccordionDetails>
            {children}
          </AccordionDetails>
        </MuiAccordion>
      ) : (
        <MuiAccordion expanded={expanded} onClick={(() => setExpanded(!expanded))} className={clsx(classes.accordion)}>
          <MuiAccordionSummary expandIcon={expanded ? <Minimize /> : <Add />}>
            <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>{title}</Typography>
          </MuiAccordionSummary>
          <AccordionDetails>
            {children}
          </AccordionDetails>
        </MuiAccordion>
      )}
    </>
  );
};
export default Accordion;
